export default __webpack_public_path__ + "static/media/billBoardwithoutbg.ca4c2837.png";